import { render, staticRenderFns } from "./AppFormCabecalho.vue?vue&type=template&id=5cd8ea98&"
import script from "./AppFormCabecalho.vue?vue&type=script&lang=js&"
export * from "./AppFormCabecalho.vue?vue&type=script&lang=js&"
import style0 from "./AppFormCabecalho.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports